export enum SkeletonTypeEnum {
  SITUATION_LIST_ITEM,
  SITUATION_CARD,
}
